export {
  getSentenceSpeechState,
  playSentenceVoiceSample,
  previewSentenceVoice,
  type SentenceSpeechListener,
  type SentenceSpeechState,
  speakSentence,
  stopSentenceSpeech,
  subscribeToSentenceSpeech,
} from "#sentence-speech-player";
export {
  registerSentenceVoiceChooser,
  type SentenceVoiceChoiceRequest,
  type SentenceVoiceChooser,
} from "#sentence-voice-choice-request";
export { useSentenceSpeech } from "#use-sentence-speech";
